(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pd-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pd-collection]').forEach((root)=>{
    requestAnimationFrame(()=>root.querySelector('.pd-collection__hero')?.classList.add('is-visible'));
    const teamInput=root.querySelector('[data-pd-team-search]'),teamTrack=root.querySelector('[data-pd-team-track]');
    if(teamInput&&teamTrack){const teams=[...teamTrack.querySelectorAll('[data-pd-team]')],count=root.querySelector('[data-pd-team-count]'),empty=root.querySelector('[data-pd-team-empty]');const filterTeams=()=>{const q=teamInput.value.trim().toLowerCase();let visible=0;teams.forEach(team=>{team.hidden=!team.dataset.pdTeamName.includes(q);if(!team.hidden)visible++});count.textContent=visible;empty.hidden=visible>0};teamInput.addEventListener('input',filterTeams);const prev=root.querySelector('[data-pd-team-prev]'),next=root.querySelector('[data-pd-team-next]');const step=()=>Math.max(teamTrack.clientWidth*.8,160);const syncArrows=()=>{const max=teamTrack.scrollWidth-teamTrack.clientWidth;const scrollable=max>4;[prev,next].forEach(b=>{if(b)b.hidden=!scrollable});if(prev)prev.disabled=teamTrack.scrollLeft<=4;if(next)next.disabled=teamTrack.scrollLeft>=max-4};prev?.addEventListener('click',()=>teamTrack.scrollBy({left:-step(),behavior:'smooth'}));next?.addEventListener('click',()=>teamTrack.scrollBy({left:step(),behavior:'smooth'}));teamTrack.addEventListener('scroll',syncArrows,{passive:true});teamInput.addEventListener('input',()=>{teamTrack.scrollLeft=0;syncArrows()});window.addEventListener('resize',syncArrows);window.addEventListener('load',syncArrows);count.textContent=teams.length;syncArrows()}
    const retro=root.querySelector('[data-pd-retro]');
    if(retro){let active='clubs';const viewport=retro.querySelector('[data-pd-retro-viewport]'),search=root.querySelector('[data-pd-retro-search]'),clear=root.querySelector('[data-pd-retro-clear]');const currentPanel=()=>retro.querySelector(`[data-pd-retro-panel="${active}"]`);const filterRetro=()=>{const query=(search?.value||'').trim().toLowerCase();currentPanel()?.querySelectorAll('[data-pd-retro-team]').forEach(item=>item.hidden=query&&!item.dataset.pdRetroName.includes(query));if(clear)clear.style.opacity=query?'1':'';viewport.scrollTo({left:0,behavior:'instant'});const cards=[...root.querySelectorAll('[data-pd-title]')];let visible=0;cards.forEach(card=>{const hide=query&&!card.dataset.pdTitle.includes(query);card.hidden=hide;if(!hide)visible++});const visibleCount=root.querySelector('[data-pd-visible-count]'),productEmpty=root.querySelector('[data-pd-search-empty]');if(visibleCount)visibleCount.textContent=visible;if(productEmpty)productEmpty.hidden=visible>0};retro.querySelectorAll('[data-pd-retro-tab]').forEach(button=>button.addEventListener('click',()=>{active=button.dataset.pdRetroTab;retro.querySelectorAll('[data-pd-retro-tab]').forEach(tab=>{const selected=tab===button;tab.classList.toggle('is-active',selected);tab.setAttribute('aria-selected',selected?'true':'false')});retro.querySelectorAll('[data-pd-retro-panel]').forEach(panel=>panel.hidden=panel.dataset.pdRetroPanel!==active);if(search)search.value='';filterRetro()}));search?.addEventListener('input',filterRetro);clear?.addEventListener('click',()=>{search.value='';filterRetro();search.focus()});retro.querySelector('[data-pd-retro-prev]')?.addEventListener('click',()=>viewport.scrollBy({left:-520,behavior:'smooth'}));retro.querySelector('[data-pd-retro-next]')?.addEventListener('click',()=>viewport.scrollBy({left:520,behavior:'smooth'}))}
    const productInput=root.querySelector('[data-pd-product-search]'),grid=root.querySelector('[data-pd-product-grid]'),visibleCount=root.querySelector('[data-pd-visible-count]'),productEmpty=root.querySelector('[data-pd-search-empty]'),pagination=root.querySelector('.pd-pagination');
    const originalGrid=grid?grid.innerHTML:'';
    const originalCount=visibleCount?visibleCount.textContent:'';
    if(root.hasAttribute('data-pd-immediate-collection')&&grid){
      const sizeBox=root.querySelector('[data-pd-immediate-size-filters]');
      const nativePagination=root.querySelector('[data-pd-native-pagination]');
      const more=root.querySelector('[data-pd-immediate-more]');
      let cards=[],loading=null,selectedSize='',shown=24,searchTimer=0;
      const load=()=>{
        if(loading)return loading;
        loading=(async()=>{
          const getPage=async(page)=>{
            const url=new URL(window.location.pathname,window.location.origin);
            url.searchParams.set('page',String(page));
            const response=await fetch(url.toString(),{credentials:'same-origin'});
            if(!response.ok)throw new Error('No se pudo cargar la página '+page);
            return new DOMParser().parseFromString(await response.text(),'text/html');
          };
          const first=await getPage(1);
          const pageCount=Number(first.querySelector('[data-pd-immediate-collection] [data-pd-page-count]')?.dataset.pdPageCount||1);
          const pages=[first,...await Promise.all(Array.from({length:Math.max(0,pageCount-1)},(_,index)=>getPage(index+2)))];
          cards=pages.flatMap(page=>[...page.querySelectorAll('[data-pd-immediate-collection] [data-pd-product-grid] > .pd-card')]);
          const counts=new Map();
          cards.forEach(card=>card.dataset.pdImmediateSizes.split('|').filter(Boolean).forEach(size=>counts.set(size,(counts.get(size)||0)+1)));
          const order=['2 años','4 años','6 años','8 años','10 años','12 años','14 años','XS','S','M','L','XL','2XL','3XL','4XL'];
          sizeBox.replaceChildren();
          [...counts].sort((a,b)=>{const ai=order.indexOf(a[0]),bi=order.indexOf(b[0]);return (ai<0?99:ai)-(bi<0?99:bi)||a[0].localeCompare(b[0])}).forEach(([size,count])=>{
            const label=document.createElement('label');label.className='pd-collection__filter-value';
            const left=document.createElement('span'),input=document.createElement('input'),small=document.createElement('small');
            input.type='checkbox';input.value=size;input.checked=size===selectedSize;
            input.addEventListener('change',()=>{selectedSize=input.checked?size:'';sizeBox.querySelectorAll('input').forEach(other=>{if(other!==input)other.checked=false});shown=24;render()});
            left.append(input,document.createTextNode(' '+size));small.textContent='('+count+')';label.append(left,small);sizeBox.append(label);
          });
        })().catch(error=>{loading=null;sizeBox.textContent='No pudimos cargar las tallas. Vuelve a intentarlo.';throw error});
        return loading;
      };
      const render=()=>{
        const query=(productInput?.value||'').trim().toLowerCase();
        if(!selectedSize&&!query){grid.innerHTML=originalGrid;if(visibleCount)visibleCount.textContent=originalCount;if(productEmpty)productEmpty.hidden=true;if(nativePagination)nativePagination.hidden=false;if(more)more.hidden=true;return}
        const found=cards.filter(card=>(!selectedSize||card.dataset.pdImmediateSizes.split('|').includes(selectedSize))&&(!query||card.dataset.pdTitle.includes(query)));
        grid.innerHTML=found.slice(0,shown).map(card=>card.outerHTML).join('');
        if(visibleCount)visibleCount.textContent=String(found.length);
        if(productEmpty){productEmpty.hidden=found.length>0;productEmpty.textContent='No hay camisetas de entrega inmediata con esos filtros.'}
        if(nativePagination)nativePagination.hidden=true;
        if(more)more.hidden=found.length<=shown;
      };
      const filter=async()=>{try{await load();render()}catch(error){if(productEmpty){productEmpty.hidden=false;productEmpty.textContent='No se pudieron cargar los filtros. Inténtalo de nuevo.'}}};
      productInput?.addEventListener('input',()=>{clearTimeout(searchTimer);shown=24;searchTimer=setTimeout(filter,180)});
      root.querySelector('[data-pd-store-search]')?.addEventListener('submit',event=>{event.preventDefault();shown=24;filter()});
      root.querySelector('[data-pd-product-clear]')?.addEventListener('click',()=>{if(!productInput)return;productInput.value='';shown=24;render();productInput.focus()});
      root.querySelector('[data-pd-immediate-clear]')?.addEventListener('click',()=>{selectedSize='';sizeBox.querySelectorAll('input').forEach(input=>input.checked=false);if(productInput)productInput.value='';shown=24;render()});
      more?.addEventListener('click',()=>{shown+=24;render()});
      if('requestIdleCallback'in window)requestIdleCallback(()=>load().catch(()=>{}));else setTimeout(()=>load().catch(()=>{}),900);
    }else{
    let searchTimer=0,searchId=0;
    const paintStoreSearch=(html,count,query)=>{
      if(!grid) return;
      if(!query){grid.innerHTML=originalGrid;if(visibleCount)visibleCount.textContent=originalCount;if(productEmpty)productEmpty.hidden=true;if(pagination)pagination.hidden=false;return}
      grid.innerHTML=html||'';
      if(visibleCount)visibleCount.textContent=String(count||0);
      if(productEmpty){productEmpty.hidden=count>0;productEmpty.textContent=count>0?'':'No encontramos camisetas con ese nombre.'}
      if(pagination)pagination.hidden=true;
    };
    const runStoreSearch=()=>{
      const query=(productInput?.value||'').trim();
      clearTimeout(searchTimer);
      if(query.length<2){paintStoreSearch('',0,'');return}
      searchTimer=setTimeout(async()=>{
        const id=++searchId;
        try{
          const response=await fetch('/search?q='+encodeURIComponent(query)+'&type=product&view=pd-json');
          const data=await response.json();
          if(id!==searchId) return;
          paintStoreSearch(data.html||'',data.count||0,query);
        }catch(error){
          if(id===searchId) window.location.href='/search?q='+encodeURIComponent(query)+'&type=product';
        }
      },280);
    };
    productInput?.addEventListener('input',runStoreSearch);
    root.querySelector('[data-pd-product-clear]')?.addEventListener('click',()=>{if(!productInput)return;productInput.value='';paintStoreSearch('',0,'');productInput.focus()});
    }
    const filterToggle=root.querySelector('[data-pd-filter-toggle]');const setFilters=(open)=>{root.classList.toggle('is-filters-open',open);filterToggle?.setAttribute('aria-expanded',open?'true':'false');document.documentElement.style.overflow=open?'hidden':''};filterToggle?.addEventListener('click',()=>setFilters(true));root.querySelectorAll('[data-pd-filter-close]').forEach(button=>button.addEventListener('click',()=>setFilters(false)));document.addEventListener('keydown',event=>{if(event.key==='Escape')setFilters(false)});
    root.querySelectorAll('[data-pd-view]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-pd-view]').forEach(item=>item.classList.toggle('is-active',item===button));root.querySelector('[data-pd-product-grid]')?.classList.toggle('is-list',button.dataset.pdView==='list')}))
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pd-clubs]').forEach((root)=>{const viewport=root.querySelector('[data-pd-club-viewport]');const previous=root.querySelector('[data-pd-club-previous]');const next=root.querySelector('[data-pd-club-next]');const search=root.querySelector('[data-pd-club-search]');const clear=root.querySelector('[data-pd-club-search-clear]');let activeKey='retro';const labels={leagues:'Buscar liga...',teams:'Buscar equipo...',retro:'Buscar club o país...'};const activePanel=()=>root.querySelector(`[data-pd-tab-panel="${activeKey}"]`);const update=()=>{const atStart=viewport.scrollLeft<=2;const atEnd=viewport.scrollLeft+viewport.clientWidth>=viewport.scrollWidth-2;previous.disabled=atStart;next.disabled=atEnd};const filter=()=>{const query=search.value.trim().toLocaleLowerCase('es');activePanel()?.querySelectorAll('a').forEach(card=>{card.hidden=query&&!card.textContent.toLocaleLowerCase('es').includes(query)});clear.hidden=!query;viewport.scrollTo({left:0,behavior:'instant'});requestAnimationFrame(update)};const scroll=(direction)=>viewport.scrollBy({left:direction*Math.max(240,viewport.clientWidth*.72),behavior:'smooth'});previous.addEventListener('click',()=>scroll(-1));next.addEventListener('click',()=>scroll(1));viewport.addEventListener('scroll',update,{passive:true});viewport.addEventListener('keydown',(event)=>{if(event.key==='ArrowLeft'){event.preventDefault();scroll(-1)}if(event.key==='ArrowRight'){event.preventDefault();scroll(1)}});search.addEventListener('input',filter);clear.addEventListener('click',()=>{search.value='';filter();search.focus()});root.querySelectorAll('[data-pd-tab]').forEach((button)=>button.addEventListener('click',()=>{activeKey=button.dataset.pdTab;root.querySelectorAll('[data-pd-tab]').forEach((item)=>{const active=item===button;item.classList.toggle('is-active',active);item.setAttribute('aria-selected',active?'true':'false')});root.querySelectorAll('[data-pd-tab-panel]').forEach((panel)=>{panel.hidden=panel.dataset.pdTabPanel!==activeKey;panel.querySelectorAll('a').forEach(card=>card.hidden=false)});search.value='';search.placeholder=labels[activeKey];clear.hidden=true;viewport.scrollTo({left:0,behavior:'instant'});requestAnimationFrame(update)}));window.addEventListener('resize',update,{passive:true});update()});
  document.querySelectorAll('[data-pd-feature-gallery]').forEach((gallery)=>{const slides=[...gallery.querySelectorAll('[data-pd-feature-slide]')];const thumbs=[...gallery.querySelectorAll('[data-pd-feature-thumb]')];const nav=gallery.querySelectorAll('.pd-home__feature-nav');if(slides.length<2){nav.forEach((button)=>button.hidden=true);if(thumbs.length)gallery.querySelector('.pd-home__feature-thumbs')?.setAttribute('hidden','');return}let index=Math.max(0,slides.findIndex((slide)=>slide.classList.contains('is-active')));const show=(next)=>{index=(next+slides.length)%slides.length;slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===index));thumbs.forEach((thumb,i)=>thumb.classList.toggle('is-active',i===index))};gallery.querySelector('[data-pd-feature-prev]')?.addEventListener('click',()=>show(index-1));gallery.querySelector('[data-pd-feature-next]')?.addEventListener('click',()=>show(index+1));thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)))});
  document.querySelectorAll('[data-pd-feature-countdown]').forEach((el)=>{const boxes=el.querySelectorAll('strong');const tick=()=>{const end=new Date();end.setHours(24,0,0,0);const ms=Math.max(0,end-Date.now());const parts=[Math.floor(ms/86400000),Math.floor(ms/3600000)%24,Math.floor(ms/60000)%60];boxes.forEach((box,i)=>{if(box.firstChild)box.firstChild.textContent=String(parts[i]).padStart(2,'0')})};tick();setInterval(tick,1000)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-nations"]) return;
  try {
    
  document.querySelectorAll('[data-pd-nations]').forEach((root)=>{
    const input=root.querySelector('[data-pd-nations-search]');
    const clear=root.querySelector('[data-pd-nations-clear]');
    const empty=root.querySelector('[data-pd-nations-empty]');
    const cards=[...root.querySelectorAll('[data-pd-nations-card]')];
    const filter=()=>{
      const q=(input?.value||'').trim().toLowerCase();
      let visible=0;
      cards.forEach((card)=>{
        const match=!q||(card.dataset.pdNationsName||'').includes(q);
        card.hidden=!match;
        if(match) visible+=1;
      });
      if(empty) empty.hidden=visible>0;
    };
    input?.addEventListener('input',filter);
    clear?.addEventListener('click',()=>{if(input)input.value='';filter();input?.focus()});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pd-product]').forEach((root)=>{
    if(root.dataset.pdBound==='true') return;
    root.dataset.pdBound='true';
    const form=root.querySelector('[data-pd-product-form]');
    const input=root.querySelector('[data-pd-variant-id]');
    const feedback=root.querySelector('[data-pd-feedback]');
    const add=root.querySelector('[data-pd-add]');
    const sizePos=Number(root.dataset.pdSizeOption||0)-1;
    const versionPos=Number(root.dataset.pdVersionOption||0)-1;
    const deliveryPos=Number(root.dataset.pdDeliveryOption||0)-1;
    const fanOnly=root.dataset.pdFanOnly==='true';
    const allVariants=JSON.parse(root.querySelector('[data-pd-variants]').textContent);
    const variants=fanOnly&&versionPos>=0
      ?allVariants.filter((item)=>/fan/i.test(String(item.options[versionPos]||'')))
      :allVariants;
    const customCents=Number(root.dataset.pdCustomCents||0);
    const customId=Number(root.dataset.pdCustomId||0);
    const patchCents=Number(root.dataset.pdPatchCents||0);
    
    const money=(cents)=>new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',maximumFractionDigits:0}).format(Number(cents||0)/100);
    const selectedPatchItems=()=>[...new Map([...root.querySelectorAll('[data-pd-patch-choice]:checked')].map((choice)=>[choice.dataset.pdPatchId,{id:Number(choice.dataset.pdPatchId),name:choice.dataset.pdPatchName,price:Number(choice.dataset.pdPatchPrice)}])).values()];
    const patchesOn=()=>selectedPatchItems().length>0;
    const patchTotal=()=>selectedPatchItems().reduce((sum,patch)=>sum+patch.price,0);
    const selectedPatches=()=>selectedPatchItems().map((patch)=>patch.name);
    const selections=(variants[0]?.options||allVariants[0]?.options||[]).slice();
    if(sizePos>=0) selections[sizePos]='';
    if(versionPos>=0) selections[versionPos]=fanOnly?(variants[0]?.options[versionPos]||''):'';
    const immediateValue='Entrega inmediata';
    const orderValue=deliveryPos>=0
      ? variants.map((item)=>item.options[deliveryPos]).find((value)=>value==='Bajo pedido'||value==='Pedido normal')||'Bajo pedido'
      : 'Bajo pedido';
    const requestedImmediate=new URLSearchParams(window.location.search).get('entrega')==='inmediata';
    const hasImmediate=deliveryPos>=0&&variants.some((item)=>item.options[deliveryPos]===immediateValue&&item.available!==false);
    if(deliveryPos>=0) selections[deliveryPos]=requestedImmediate&&hasImmediate?immediateValue:orderValue;
    const normalizeSize=(value)=>{
      const raw=String(value||'').toUpperCase().replace(/\s+/g,'');
      if(raw==='XXXL') return '3XL';
      if(raw==='XXXXL') return '4XL';
      return raw;
    };
    const normalizeVersion=(value)=>{
      const raw=String(value||'').toLowerCase();
      if(raw.includes('player')||raw.includes('jugador')) return 'jugador';
      if(raw.includes('fan')) return 'fan';
      return raw;
    };
    if(versionPos>=0){
      const availableVersions=[...new Set(variants.map((item)=>normalizeVersion(item.options[versionPos])))];
      if(availableVersions.length===1) selections[versionPos]=variants[0].options[versionPos];
    }
    const isBigSize=(value)=>{const size=normalizeSize(value);return size==='3XL'||size==='4XL'};
    const isPlayerVersion=(value)=>normalizeVersion(value)==='jugador';
    let customName='', customNumber='', adding=false;
    if(root.dataset.pdNamedPlayer==='true' && versionPos>=0 && !fanOnly){
      const jugadorVariant=variants.find((item)=>normalizeVersion(item.options[versionPos])==='jugador');
      if(jugadorVariant) selections[versionPos]=jugadorVariant.options[versionPos];
    }
    const openCart=()=>{if(window.pdOpenCart){window.pdOpenCart();return}const drawer=document.querySelector('[data-pd-cart]');if(drawer){drawer.hidden=false;document.documentElement.style.overflow='hidden'}};
    const sizeReady=()=>sizePos<0||Boolean(selections[sizePos]);
    const versionReady=()=>versionPos<0||Boolean(selections[versionPos]);
    const immediateSelected=()=>deliveryPos>=0&&selections[deliveryPos]===immediateValue;
    const optionMatches=(value,index,requireAll)=>{
      if(index===sizePos){
        if(requireAll||selections[sizePos]) return normalizeSize(value)===normalizeSize(selections[sizePos]);
        return true;
      }
      if(index===versionPos){
        if(requireAll||selections[versionPos]) return normalizeVersion(value)===normalizeVersion(selections[versionPos]);
        return true;
      }
      return value===selections[index];
    };
    const findVariant=(requireAll)=>variants.find((item)=>item.options.every((value,index)=>optionMatches(value,index,requireAll)));
    const findPriceVariant=()=>{
      if(sizeReady()&&versionReady()) return findVariant(true);
      return findVariant(false);
    };
    function render(){
      const versionSet=versionReady();
      const sizeField=root.querySelector('.pd-product__options--size');
      sizeField?.classList.toggle('is-locked',versionPos>=0&&!versionSet);
      const versionLabel=root.querySelector('[data-pd-option-label="'+root.dataset.pdVersionOption+'"]');
      if(versionLabel){
        if(!versionSet) versionLabel.textContent='Elige una versión';
        else versionLabel.textContent=selections[versionPos];
      }
      root.querySelectorAll('[data-pd-option]').forEach((button)=>{
        const position=Number(button.dataset.pdOption)-1;
        const selected=position===sizePos
          ? normalizeSize(selections[position])===normalizeSize(button.dataset.pdValue)
          : position===versionPos
            ? normalizeVersion(selections[position])===normalizeVersion(button.dataset.pdValue)
            : selections[position]===button.dataset.pdValue;
        button.classList.toggle('is-selected',selected);
      });
      root.querySelectorAll('[data-pd-version-chip]').forEach((button)=>{
        if(deliveryPos<0) return;
        button.disabled=!variants.some((item)=>normalizeVersion(item.options[versionPos])===normalizeVersion(button.dataset.pdValue)&&item.options[deliveryPos]===selections[deliveryPos]&&item.available!==false);
      });
      root.querySelectorAll('[data-pd-option="'+root.dataset.pdDeliveryOption+'"]').forEach((button)=>{
        button.disabled=button.dataset.pdValue===immediateValue&&!hasImmediate;
        button.classList.toggle('is-unavailable',button.disabled);
      });
      const deliveryNote=root.querySelector('[data-pd-delivery-note]');
      if(deliveryNote){
        deliveryNote.textContent=requestedImmediate&&!hasImmediate
          ?'La unidad de entrega inmediata se agotó. Esta camiseta sigue disponible bajo pedido.'
          :immediateSelected()
            ?'Una unidad por talla y versión. Entrega estimada en 1–3 días hábiles para destinos habilitados en Colombia.'
            :'Disponible bajo pedido. Plazo estimado desde 3 semanas.';
      }
      root.querySelectorAll('[data-pd-size-chip]').forEach((button)=>{
        const size=button.dataset.pdValue;
        const blockedByVersion=versionPos>=0&&!versionSet;
        const blockedByPlayer=versionSet&&isPlayerVersion(selections[versionPos])&&isBigSize(size);
        const exists=variants.some((item)=>{
          const sizeOk=sizePos<0||normalizeSize(item.options[sizePos])===normalizeSize(size);
          const versionOk=versionPos<0||!versionSet||normalizeVersion(item.options[versionPos])===normalizeVersion(selections[versionPos]);
          const deliveryOk=deliveryPos<0||item.options[deliveryPos]===selections[deliveryPos];
          return sizeOk&&versionOk&&deliveryOk&&item.available!==false;
        });
        button.hidden=blockedByPlayer;
        button.disabled=blockedByVersion||blockedByPlayer||!exists;
        button.classList.toggle('is-unavailable',versionSet&&!blockedByPlayer&&!exists);
      });
      const priceVariant=findPriceVariant();
      const variant=sizeReady()&&versionReady()?findVariant(true):null;
      const ready=sizeReady()&&versionReady();
      if(variant) input.value=variant.id;
      else if(priceVariant&&ready===false) input.value=priceVariant.id;
      const base=Number(priceVariant?.price||variants[0]?.price||0);
      const extra=((customName||customNumber)?customCents:0)+patchTotal();
      const total=money(base+extra);
      let html='<strong>'+total+'</strong>';
      if(priceVariant?.compare_at_price>priceVariant?.price){
        const pct=Math.round((Number(priceVariant.compare_at_price)-Number(priceVariant.price))*20/Number(priceVariant.compare_at_price))*5;
        html+='<s>'+money(priceVariant.compare_at_price)+'</s><em>Ahorra '+pct+'%</em>';
      }
      root.querySelectorAll('[data-pd-price]').forEach((priceNode)=>{priceNode.innerHTML=html});
      root.querySelectorAll('[data-pd-price-dock]').forEach((priceNode)=>{
        if(priceNode.closest('.pd-product__dock')) priceNode.innerHTML='<small>Total</small><strong>'+total+'</strong>';
        else priceNode.textContent=total;
      });
      if(versionPos>=0&&!versionSet){
        add.disabled=true;
        add.textContent='Selecciona versión';
        feedback.textContent='';
        return;
      }
      if(!sizeReady()){
        add.disabled=true;
        add.textContent='Selecciona talla';
        feedback.textContent='';
        return;
      }
      if(!variant){
        add.disabled=true;
        add.textContent='No disponible';
        feedback.textContent='Esta combinación no está disponible.';
        return;
      }
      if((customName||customNumber)&&(!customId||customCents!==1000000)){
        add.disabled=true;
        add.textContent='Personalización no disponible';
        feedback.textContent='No podemos cobrar la personalización correctamente en este momento.';
        return;
      }
      if(selectedPatchItems().some((patch)=>!patch.id||patch.price!==500000)){
        add.disabled=true;
        add.textContent='Parches no disponibles';
        feedback.textContent='No podemos cobrar los parches correctamente en este momento.';
        return;
      }
      add.disabled=!variant.available;
      add.textContent=variant.available?(immediateSelected()?'Agregar · entrega inmediata':'Agregar a la bolsa'):'Agotado';
      feedback.textContent='';
    }
    root.querySelectorAll('[data-pd-option]').forEach((button)=>button.addEventListener('click',()=>{
      if(button.disabled) return;
      const position=Number(button.dataset.pdOption)-1;
      selections[position]=button.dataset.pdValue;
      if(position===versionPos&&sizePos>=0) selections[sizePos]='';
      if(position===deliveryPos){
        if(versionPos>=0) selections[versionPos]=fanOnly?(variants[0]?.options[versionPos]||''):'';
        if(sizePos>=0) selections[sizePos]='';
      }
      render();
    }));
    const gallery=root.querySelector('[data-pd-gallery]');
    if(gallery){
      const slides=[...gallery.querySelectorAll('[data-pd-media]')];
      const pager=gallery.querySelector('[data-pd-pager]');
      let index=0;
      const thumbs=[...gallery.querySelectorAll('[data-pd-thumb]')];
      const show=(next)=>{if(!slides.length)return;index=(next+slides.length)%slides.length;slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===index));thumbs.forEach((thumb,i)=>thumb.classList.toggle('is-active',i===index));if(pager)pager.textContent=String(index+1)};
      gallery.querySelector('[data-pd-gallery-prev]')?.addEventListener('click',()=>show(index-1));
      gallery.querySelector('[data-pd-gallery-next]')?.addEventListener('click',()=>show(index+1));
      thumbs.forEach((thumb)=>thumb.addEventListener('click',()=>show(Number(thumb.dataset.pdThumb))));
    }
    root.querySelectorAll('[data-pd-patch-choice]').forEach((choice)=>choice.addEventListener('change',()=>{
      root.querySelectorAll('[data-pd-patch-choice]').forEach((other)=>{
        if(other.dataset.pdPatchId===choice.dataset.pdPatchId) other.checked=choice.checked;
      });
      render();
    }));
    const customizeModal=root.querySelector('[data-pd-customize-modal]');
    const guideModal=root.querySelector('[data-pd-guide-modal]');
    const nameInput=root.querySelector('[data-pd-customize-name]');
    const numberInput=root.querySelector('[data-pd-customize-number]');
    const summary=root.querySelector('[data-pd-custom-summary]');
    const applyCustom=()=>{
      customName=(nameInput?.value||'').trim().toUpperCase();
      customNumber=(numberInput?.value||'').trim();
      const nameField=root.querySelector('[data-pd-name]');
      const numberField=root.querySelector('[data-pd-number]');
      if(nameField) nameField.value=customName;
      if(numberField) numberField.value=customNumber;
      if(summary){
        summary.hidden=!(customName||customNumber);
        summary.textContent=(customName||customNumber)?(customName+(customNumber?' · #'+customNumber:'')):'';
      }
      render();
    };
    nameInput?.addEventListener('input',applyCustom);
    numberInput?.addEventListener('input',applyCustom);
    const customizeOpen=root.querySelector('[data-pd-customize-open]');
    const customizeClose=root.querySelector('[data-pd-customize-close]');
    const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
    let customizeCloseTimer;
    let customizeOpenFrame;
    const openCustomize=()=>{
      clearTimeout(customizeCloseTimer);
      cancelAnimationFrame(customizeOpenFrame);
      customizeModal.hidden=false;
      document.documentElement.style.overflow='hidden';
      applyCustom();
      customizeOpenFrame=requestAnimationFrame(()=>{
        if(!customizeModal.hidden) customizeModal.classList.add('is-open');
      });
      customizeClose?.focus({preventScroll:true});
    };
    const closeCustomize=()=>{
      if(customizeModal.hidden) return;
      cancelAnimationFrame(customizeOpenFrame);
      customizeModal.classList.remove('is-open');
      clearTimeout(customizeCloseTimer);
      const finish=()=>{
        customizeModal.hidden=true;
        document.documentElement.style.overflow='';
      };
      if(reduceMotion.matches) finish();
      else customizeCloseTimer=setTimeout(finish,280);
      customizeOpen?.focus({preventScroll:true});
    };
    customizeOpen?.addEventListener('click',openCustomize);
    customizeClose?.addEventListener('click',closeCustomize);
    root.querySelector('[data-pd-customize-save]')?.addEventListener('click',()=>{
      applyCustom();
      closeCustomize();
    });
    root.querySelector('[data-pd-size-guide]')?.addEventListener('click',()=>{guideModal.hidden=false;document.documentElement.style.overflow='hidden'});
    root.querySelector('[data-pd-guide-close]')?.addEventListener('click',()=>{guideModal.hidden=true;document.documentElement.style.overflow=''});
    customizeModal?.addEventListener('click',(event)=>{if(event.target===customizeModal) closeCustomize()});
    document.addEventListener('keydown',(event)=>{if(event.key==='Escape'&&!customizeModal.hidden) closeCustomize()});
    guideModal?.addEventListener('click',(event)=>{if(event.target===guideModal){guideModal.hidden=true;document.documentElement.style.overflow=''}});
    root.querySelectorAll('[data-pd-policy-tab]').forEach((button)=>button.addEventListener('click',()=>{
      root.querySelectorAll('[data-pd-policy-tab]').forEach((tab)=>tab.classList.toggle('is-active',tab===button));
      root.querySelectorAll('[data-pd-policy-panel]').forEach((panel)=>panel.hidden=panel.dataset.pdPolicyPanel!==button.dataset.pdPolicyTab);
    }));
    root.querySelectorAll('[data-pd-accordion]').forEach((accordion)=>{
      const trigger=accordion.querySelector('[data-pd-accordion-trigger]');
      const panel=accordion.querySelector('[data-pd-accordion-panel]');
      trigger?.addEventListener('click',()=>{
        const open=trigger.getAttribute('aria-expanded')==='true';
        trigger.setAttribute('aria-expanded',open?'false':'true');
        accordion.classList.toggle('is-open',!open);
        if(panel) panel.hidden=open;
      });
    });
    const addConfiguredJersey=async()=>{
      if(adding||window.pdAddLock||!versionReady()||!sizeReady()||add.disabled) return;
      adding=true;
      window.pdAddLock=true;
      add.disabled=true;
      feedback.textContent='Agregando…';
      try{
        applyCustom();
        const variantId=Number(input.value);
        if(!variantId) throw new Error('variant');
        const title=root.dataset.pdTitle||'';
        const wantCustom=Boolean(customName||customNumber);
        const wantPatches=patchesOn();
        const patchNames=selectedPatches();
        if(wantCustom&&(!customId||customCents!==1000000)) throw new Error('personalization-addon');
        if(selectedPatchItems().some((patch)=>!patch.id||patch.price!==500000)) throw new Error('patch-addon');
        const bundle='pd'+Date.now().toString(36)+Math.random().toString(36).slice(2,7);
        const properties={_Bundle:bundle};
        if(customName) properties['Nombre']=customName;
        if(customNumber) properties['Número']=customNumber;
        if(wantPatches) properties['Parches']=patchNames.join(', ');
        const extras=[];
        if(wantCustom) extras.push({id:customId,quantity:1,parent_id:variantId,properties:{_Bundle:bundle,_Addon:'personalizacion',_Para:title}});
        selectedPatchItems().forEach((patch)=>extras.push({id:patch.id,quantity:1,parent_id:variantId,properties:{_Bundle:bundle,_Addon:'parches',_Para:title,Parche:patch.name}}));
        const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1,properties},...extras]})});
        if(!response.ok) throw new Error('add');
        const cart=await fetch('/cart.js').then((res)=>res.json());
        const linked=(cart.items||[]).filter((item)=>item.properties?._Bundle===bundle);
        const parent=linked.find((item)=>Number(item.variant_id)===variantId&&!item.parent_relationship);
        const hasEveryAddon=extras.every((extra)=>linked.some((item)=>Number(item.variant_id)===extra.id&&Number(item.quantity)===1&&Number(item.original_price)===(extra.properties._Addon==='parches'?500000:1000000)&&item.parent_relationship?.parent_key===parent?.key));
        if(linked.length!==extras.length+1||!parent||!hasEveryAddon){
          const updates=Object.fromEntries(linked.map((item)=>[item.key,0]));
          if(linked.length) await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});
          throw new Error('verify-cart');
        }
        window.pdRenderCartDrawer?.(cart);
        feedback.textContent='Listo: ya está en tu bolsa.';
        openCart();
      }catch(error){
        feedback.textContent='No fue posible agregarla. Intenta de nuevo.';
      }finally{
        adding=false;
        window.pdAddLock=false;
        add.disabled=false;
        render();
      }
    };
    add?.addEventListener('click',(event)=>{event.preventDefault();event.stopPropagation();addConfiguredJersey();});
    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-recommended"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event)=>{
    const prev=event.target.closest('[data-pd-rec-prev]');
    const next=event.target.closest('[data-pd-rec-next]');
    if(!prev && !next) return;
    const track=event.target.closest('[data-pd-recommended]')?.querySelector('[data-pd-rec-track]');
    if(!track) return;
    track.scrollBy({left: next ? Math.max(280, track.clientWidth * .7) : -Math.max(280, track.clientWidth * .7), behavior:'smooth'});
  });
  const loadRecommended=(root)=>{
    if(!root || root.dataset.performed==='true' || !root.dataset.url || root.dataset.loading==='true') return;
    root.dataset.loading='true';
    fetch(root.dataset.url).then((response)=>response.text()).then((html)=>{
      const doc=new DOMParser().parseFromString(html,'text/html');
      const next=doc.querySelector('[data-pd-recommended]');
      if(next && next.querySelector('.pd-recommended__track')) root.replaceWith(next);
    }).catch(()=>{}).finally(()=>{ if(root.isConnected) root.dataset.loading='false'; });
  };
  const watchRecommended=()=>{
    document.querySelectorAll('[data-pd-recommended]').forEach((root)=>{
      if(root.dataset.watched==='true') return;
      root.dataset.watched='true';
      const observer=new IntersectionObserver((entries)=>{
        if(!entries[0].isIntersecting) return;
        observer.disconnect();
        loadRecommended(root);
      },{rootMargin:'0px 0px 240px 0px'});
      observer.observe(root);
    });
  };
  watchRecommended();
  document.addEventListener('shopify:section:load', watchRecommended);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-search"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pd-search]').forEach((root)=>{
    const input=root.querySelector('input[type="search"]');
    root.querySelector('[data-pd-search-clear]')?.addEventListener('click',()=>{if(!input)return;input.value='';input.form?.submit();});
  });

  } catch(e) { console.error(e); }
})();
})();
